import _ from 'lodash';

export type DomainSecretFieldType = 'text' | 'password' | 'url' | 'boolean';

export interface IDomainSecretFieldInDTO {
  fieldType: DomainSecretFieldType;
  value: string | number | boolean;
}

const FIELD_TYPES: DomainSecretFieldType[] = ['text', 'password', 'url', 'boolean'];

export function isDomainSecretField(value: unknown): value is IDomainSecretFieldInDTO {
  if (!_.isPlainObject(value)) return false;
  const field = value as IDomainSecretFieldInDTO;
  return _.includes(FIELD_TYPES, field.fieldType)
    && (_.isString(field.value) || _.isNumber(field.value) || _.isBoolean(field.value));
}

export function parseSecretsFromApi(raw: Record<string, unknown> | null): Record<string, IDomainSecretFieldInDTO> | null {
  if (!raw || _.isEmpty(raw)) {
    return null;
  }
  const parsed: Record<string, IDomainSecretFieldInDTO> = {};
  _.forEach(raw, (entry, key) => {
    if (isDomainSecretField(entry)) {
      parsed[key] = { fieldType: entry.fieldType, value: entry.value };
    }
  });
  return _.isEmpty(parsed) ? null : parsed;
}

export function serializeSecretsForApi(fields: Record<string, IDomainSecretFieldInDTO>): Record<string, IDomainSecretFieldInDTO> {
  return { ...fields };
}

export function buildSecretField(
  fieldType: DomainSecretFieldType,
  raw: string,
  originalValue?: string | number | boolean,
): IDomainSecretFieldInDTO {
  if (fieldType === 'boolean') {
    return { fieldType, value: raw === 'true' };
  }
  if (_.isNumber(originalValue) && fieldType === 'text' && _.trim(raw) !== '' && !_.isNaN(Number(raw))) {
    return { fieldType, value: Number(raw) };
  }
  return { fieldType, value: raw };
}

export function maskPasswordValue(value: string): string {
  const length = Math.max(value.length, 8);
  return '•'.repeat(Math.min(length, 16));
}
